// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Header_toolbar__3romb","logo":"Header_logo__2v2-W","title":"Header_title__TPvdF","hidden":"Header_hidden__3uc-r"};